import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VTooltip from 'v-tooltip'
import VueLocalForage from 'vue-localforage'
import SanitizeHTML from 'sanitize-html'
import VueSocketioExtended from 'vue-socket.io-extended'
// eslint-disable-next-line import/extensions
import io from 'socket.io-client/dist/socket.io.slim.js'
// eslint-disable-next-line
import { i18n } from '@/plugins/i18n'
import * as peopleVueUi from '@cedro-technologies/people-vue-ui'
import VueNotification from 'vue-notification'
import Moment from 'moment'
import { Picker, Emoji } from 'emoji-mart-vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import App from './screens/app/index.vue'
import './registerServiceWorker'
import ResizeMixin from './mixins/resize'
import CompatibilityMixin from './mixins/compatibility'
import ToastsMixin from './mixins/toasts'
import UpdateVersion from './mixins/updateVersion'
import Const from './helper/const'
import { version } from '../package.json'

Vue.config.productionTip = false

Vue.prototype.$eventBus = new Vue()
Vue.prototype.$sanitize = SanitizeHTML
Vue.prototype.$globalStore = store
Vue.prototype.$globalRouter = router
Vue.prototype.$globalConst = Const
Vue.prototype.$moment = Moment

Vue.use(VueAxios, axios)
Vue.use(VTooltip)
Vue.use(VueLocalForage)
Vue.use(VueNotification)
Vue.use(peopleVueUi)

Vue.component('picker', Picker)
Vue.component('emoji', Emoji)

Vue.use(
  VueSocketioExtended,
  io(Const.API_HOST(), {
    path: Const.SERVICE_EVENTHUB,
    transports: ['websocket'],
    query: {
      version
    }
  }),
  { store }
)

Vue.mixin(ResizeMixin)
Vue.mixin(CompatibilityMixin)
Vue.mixin(ToastsMixin)
Vue.mixin(UpdateVersion)

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
